import { render, staticRenderFns } from "./InspireFighterSection.vue?vue&type=template&id=52285a74&scoped=true&"
import script from "./InspireFighterSection.vue?vue&type=script&lang=ts&"
export * from "./InspireFighterSection.vue?vue&type=script&lang=ts&"
import style0 from "./InspireFighterSection.vue?vue&type=style&index=0&id=52285a74&prod&lang=scss&scoped=true&"
import style1 from "./InspireFighterSection.vue?vue&type=style&index=1&id=52285a74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52285a74",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
